import { noop } from '../libraries/lodash'
import { withDefaults } from '../helpers/lodash'
type Debug = Pick<typeof console, 'log' | 'time' | 'timeEnd' | 'error' | 'warn'>

const methods = ['log', 'time', 'timeEnd', 'error', 'warn']
let debug: Debug = withDefaults(methods, noop) as Debug

if (process.env.NODE_ENV !== 'production') {
  debug = console
}

export default debug
